import { PlusOutlined } from '@ant-design/icons';
import { Upload, Modal } from 'antd';
import React, { useState } from 'react';
import { getStsTokenApi, getPreUrl } from 'api/oss';
import { v4 as uuid } from 'uuid';
const OSS = require('ali-oss');

const AliyunOSSUpload = ({ value, onChange, disabled, name }) => {
    // const [setShowUpload] = useState(true);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [fileUrl, setFileUrl] = useState('');
    const [submitLoading, setSubmitLoading] = useState(false);

    const handleUpload = async option => {
        setSubmitLoading(true);
        getStsTokenApi({ fileName: 'test' }).then(res => {
            const client = new OSS({
                // yourRegion填写Bucket所在地域。以华东1（杭州）为例，yourRegion填写为oss-cn-hangzhou。
                region: res.region,
                // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
                accessKeyId: res.accessKeyId,
                accessKeySecret: res.accessKeySecret,
                // 从STS服务获取的安全令牌（SecurityToken）。
                stsToken: res.securityToken,
                // 填写Bucket名称。
                bucket: res.bucket,
            });
            console.log(option.file);
            client.put(option.file.url, option.file).then(result =>
                getPreUrl({ url: result.name }).then(res => {
                    option.file.url = res.url;
                    option.onSuccess(res.url, option.file);
                }),
            );
            setSubmitLoading(false);
        });
    };
    const handleChange = ({ fileList }) => {
        if (fileList.length >= 1 && fileList[0] !== '') {
            console.log(fileList);
            // setShowUpload(false);
            console.log(fileList[0]);
            fileList[0].name = fileUrl;
            console.log(fileUrl);
            fileList[0].name = fileUrl;
            onChange(fileList);
        } else {
            // setShowUpload(true);
            onChange([]);
        }
    };

    const handlePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        console.log(file.url || file.preview);
        setPreviewOpen(true);
    };

    const getBase64 = file =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    const handleRemove = file => {
        console.log(file);
        // setShowUpload(true);
        const files = (value || []).filter(v => v.url !== file.url);
        if (onChange) {
            onChange(files);
        }
        return true;
    };
    const beforeUpload = file => {
        console.log(value);
        // if (!value || value.length >= 1) {
        // return;
        // }
        const filename = uuid() + file.name;
        // @ts-ignore
        file.url = filename;
        setFileUrl(file.url);
        return true;
    };
    const handleCancel = () => setPreviewOpen(false);
    const uploadProps = {
        name: 'file',
        fileList: value,
        accept: 'image/*',
        onChange: handleChange,
        onRemove: handleRemove,
        customRequest: handleUpload,
        // data: getExtraData,
        beforeUpload,
        listType: 'picture-card',
        className: 'avatar-uploader',
        onPreview: handlePreview,
        disabled: disabled,
        Loading: { submitLoading },
        maxCount: 1,
    };
    return (
        <>
            <Upload {...uploadProps}>
                {/* {!value ? ( */}
                <div>
                    <PlusOutlined />
                    <div style={{ marginTop: 8 }}>{name}</div>
                </div>
                {/* ) : (
                    ''
                )} */}
            </Upload>
            <Modal visible={previewOpen} title={'预览'} footer={null} onCancel={handleCancel}>
                <img
                    alt="图片"
                    style={{
                        width: '100%',
                    }}
                    src={previewImage}
                />
            </Modal>
        </>
    );
};
export default AliyunOSSUpload;
